import { View } from 'react-native';

import { Body } from './Body';
import { Display } from './Display';
import { Eyebrow } from './Eyebrow';
import { SealedCard } from './SealedCard';
import { Section } from './Section';

const SEALED_POINTS = ['Attributed to a name', 'Timestamped', 'Read-only after seal'];

export function Showcase() {
  return (
    <Section
      className="bg-ink py-20"
      innerClassName="flex-col items-center gap-12 md:flex-row"
    >
      <View className="min-w-[280px] flex-1">
        <Eyebrow className="mb-3.5 text-xs tracking-[0.14em] text-signal">
          The record
        </Eyebrow>
        <Display className="mb-4 text-[40px] leading-[1.06] tracking-[-0.02em] text-on-ink">
          Proof the job got done.
        </Display>
        <Body className="mb-6 max-w-[46ch] text-[17px] leading-[1.65] text-faint">
          Completed runs are immutable. Every item, who checked it, and when is frozen. No
          quiet edits, no &quot;I&apos;m sure we did that.&quot; When an auditor, a
          supervisor, or future-you asks, the answer is already on the page.
        </Body>
        <View className="flex-row flex-wrap gap-x-7 gap-y-3">
          {SEALED_POINTS.map((point) => (
            <View key={point} className="flex-row items-center gap-2.5">
              <View className="h-[7px] w-[7px] rounded-full bg-signal" />
              <Body className="text-sm text-on-ink">{point}</Body>
            </View>
          ))}
        </View>
      </View>

      <SealedCard />
    </Section>
  );
}
